import * as React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import { IconImg } from '../../Defaults/Icon/IconImg';
import { resolveCategoryUrl } from '../../../utilities/selectors';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';

export interface Props {
  category: any;
  onClick: any;
}

function NavigationDropdownItemWindow({ category, onClick }: Props) {
  return (
    <Wrapper onClick={onClick}>
      {category.children &&
        category.children.map(item => (
          // tslint:disable-next-line:jsx-key
          <WindowRow to={resolveCategoryUrl(item.category_id, item.url)}>
            <SubCategoryImg
              alt={`Obrazok kategorie`}
              src={item.image ? item.image : '/images/zemplin/placeholder.svg'}
            />
            <FlexCol>
              <SubCategoryName>{item.category_name}</SubCategoryName>
              <SubCategoryChildren>
                {item.children.length > 0 &&
                  item.children.map((child, j) => (
                    // tslint:disable-next-line:jsx-key
                    <SubCategoryChild
                      to={resolveCategoryUrl(child.category_id, child.url)}
                    >
                      {child.category_name +
                        (j !== item.children.length - 1 ? ', ' : '')}
                    </SubCategoryChild>
                  ))}
              </SubCategoryChildren>
            </FlexCol>
          </WindowRow>
        ))}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: ${rem(650)};
  position: absolute;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.textPrimary};
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 1px 24px #00000014;
  left: ${rem(290)};
  padding: ${rem(20)} ${rem(35)};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const WindowRow = styled(Link)`
  width: 50%;
  padding: ${rem(15)} ${rem(5)};
  display: flex;
  flex-direction: row;
  text-decoration: none;
`;

const SubCategoryImg = styled(IconImg)`
  margin-right: ${rem(16)};
`;

const SubCategoryName = styled(TextP)`
  font-weight: 500;
`;

const SubCategoryChildren = styled(TextP)``;
const SubCategoryChild = styled(Link)`
  color: ${({ theme }) => theme.colors.textPrimary};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export { NavigationDropdownItemWindow };
